import React from "react";
import {
  useDisclosure,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerOverlay,
  Link,
  Text,
  Box,
} from "@chakra-ui/react";
import { useColorTheme } from "contexts/color-theme";
import { Button, IconButton } from "ui/button";
import { ChevronRightIcon, ChevronLeftIcon, LegacyCloseIcon } from "ui/icons";
import { SubNav } from "./sub-nav";
import { type NavTabProps } from "./data";
import { PlatformSubNav } from "./platform-sub-nav";

type MobileDrawerProps = { onToggleNav: () => void } & NavTabProps;

export function MobileDrawer({ label, onToggleNav, ...navItem }: MobileDrawerProps) {
  const { isOpen, onOpen: onOpenSubDrawer, onClose: onCloseSubDrawer } = useDisclosure();
  const { theme, bgColor } = useColorTheme();

  return (
    <>
      <Link
        as="button"
        type="button"
        aria-label={label}
        variant="navMobile"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        w="100%"
        height="auto"
        onClick={onOpenSubDrawer}
      >
        {label}
        <ChevronRightIcon />
      </Link>

      <Drawer
        isOpen={isOpen}
        blockScrollOnMount={false} // Scroll is already blocked from popover
        placement="right"
        size="full"
        onClose={onCloseSubDrawer}
      >
        {/* DrawerOverlay is needed for the exit transition to work. */}
        <DrawerOverlay display="none" />
        <DrawerContent bg={bgColor} color={`brand.text.${theme}`}>
          <DrawerHeader display="flex" justifyContent="space-between" alignItems="center" p="small">
            <Button variant="secondary" leftIcon={ChevronLeftIcon} onClick={onCloseSubDrawer}>
              Back
            </Button>

            <IconButton
              aria-label="Close navigation"
              icon={LegacyCloseIcon}
              onClick={() => {
                onCloseSubDrawer();
                onToggleNav();
              }}
            />
          </DrawerHeader>

          <DrawerBody p={0}>
            <Box
              pb="biggest" // Leave bottom space for OneTrust :'(
            >
              <Text
                textStyle="headline2"
                fontWeight="semibold"
                mt="bigger"
                pl="small"
                pb="big"
                borderBottom="1px"
                borderColor={`brand.header.border.${theme}`}
              >
                {label}
              </Text>
              {navItem.type === "platform" ? (
                <PlatformSubNav label={label} {...navItem} />
              ) : (
                <SubNav label={label} {...navItem} />
              )}
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
